import { useReducer, useMemo, createContext, useContext } from "react"
import { removeAuthLocal } from "../../../lib/localstorage"
import KEY from "./Const"

function initialState() {
  // Auth data now comes from server response / cookies
  // Don't read from localStorage for security
  return {}
}

function reducer(state, action) {
  switch (action.type) {
    case KEY.SET_AUTH:
      return { ...state, ...action.value }
    case KEY.LOG_OUT:
      removeAuthLocal()
      return {}
    default:
      return state
  }
}

const MyContext = createContext(initialState())
MyContext.displayName = "MyContext"

export function StoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState())

  const setAuth = (value) => {
    // Don't save to localStorage - use HTTP-only cookies instead
    return dispatch({ type: KEY.SET_AUTH, value })
  }

  const logOut = () => {
    return dispatch({ type: KEY.LOG_OUT })
  }

  // Auth state is managed by App.js via setAuth from hooks
  // No event listeners needed here

  const value = useMemo(
    () => ({
      ...state,
      authLoaded: true,
      setAuth,
      logOut
    }),
    [state]
  )
  return <MyContext.Provider value={value} {...props} />
}

const useStore = () => {
  const context = useContext(MyContext)
  if (context === undefined) {
    throw new Error("useStore must be used within StoreProvider")
  }
  return context
}

export default useStore
